export default "/images/vendor/flag-icon-css/flags/1x1/sm.svg?39b2d063adce92402a5445937c86e2dd";